"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importStar(require("react"));
const RadixSwitch = __importStar(require("@radix-ui/react-switch"));
const Text_1 = require("../../../components/Text/Text");
const Icon_1 = require("../Icon");
const Switch_styles_1 = require("./Switch.styles");
const SwitchToggle = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("div", Object.assign({ ref: forwardedRef, className: "switch-toggle" }, props),
        react_1.default.createElement(Icon_1.Icon, { size: "small", name: "On", color: "white", className: "switch-icon switch-icon-on" }),
        react_1.default.createElement(Icon_1.Icon, { size: "small", name: "Off", color: "white", className: "switch-icon switch-icon-off" }),
        react_1.default.createElement(RadixSwitch.Thumb, { className: "switch-thumb" })));
});
const SwitchLabel = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Text_1.Text, { as: "label", props: Object.assign({ ref: forwardedRef }, props), skinny: true }, children));
});
const SwitchRoot = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { size = "medium", children } = _a, props = __rest(_a, ["size", "children"]);
    return (react_1.default.createElement(Switch_styles_1.StyledSwitchRoot, Object.assign({ ref: forwardedRef, "$size": size }, props), children));
});
SwitchRoot.displayName = "Switch";
SwitchLabel.displayName = "Switch.Label";
SwitchToggle.displayName = "Switch.Toggle";
const Switch = Object.assign(SwitchRoot, {
    Label: SwitchLabel,
    Toggle: SwitchToggle,
});
exports.Switch = Switch;
//# sourceMappingURL=Switch.js.map